import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Form, Row, Col, Input, message } from "antd";
import email from "../../Assets/email.png";
import email2 from "../../Assets/email2.png";
import email3 from "../../Assets/email3.png";
import email4 from "../../Assets/email4.png";
import axios from "axios";
import '../../Style/Siginup/Siginup.scss';
import { useNavigate } from "react-router";
const EmailVerification = () => {
    const navigate = useNavigate();

    const [code, setCode] = useState(new Array(6).fill(""));
    const [timer, setTimer] = useState(60);
    const [resendDisabled, setResendDisabled] = useState(true);
    const [form] = Form.useForm()
    // const [initialValues, setInitialValues] = useState({})
    const [userId, setUserId] = useState(null)

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const userId = urlParams.get("userId")
        setUserId(userId)

    }, [form])


    useEffect(() => {
        let interval;
        if (resendDisabled) {
            interval = setInterval(() => {
                setTimer(prevTimer => {
                    if (prevTimer === 1) {
                        clearInterval(interval);
                        setResendDisabled(false);
                        return 60;
                    }
                    return prevTimer - 1;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [resendDisabled]);

    // .................Resend Code........................................................
    const handleResend = async () => {
        if (!userId) {
            message.error("User ID is missing.");
            return;
        }

        try {
            await axios.patch(
                `https://stonecore-2024.uc.r.appspot.com/v1/auth/otp/resend/${userId}`
            );
            setResendDisabled(true);
            setTimer(60);
            message.success("OTP has been resent successfully.");
        } catch (error) {
            message.error("Error resending OTP.");
            console.error("Error:", error);
        }
    };

    // .................Change Input Vakue........................................................
    const handleChange = (e, index) => {
        if (/^\d$/.test(e.target.value) || e.target.value === "") {
            const newCode = [...code];
            newCode[index] = e.target.value;
            setCode(newCode);
            // Automatically focus next input if a digit is entered
            if (e.target.value && index < code.length - 1) {
                document.getElementById(`code-input-${index + 1}`).focus();
            }
        }
    };

    // .................Copy Paste Code........................................................

    const handlePaste = (e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData("text");
        if (/^\d{6}$/.test(paste)) {
            const newCode = paste.split("");
            setCode(newCode);
            // Automatically focus the first empty input after paste
            const nextInput = newCode.findIndex((char, i) => char === "" && i < code.length);
            if (nextInput !== -1) {
                document.getElementById(`code-input-${nextInput}`).focus();
            }
        }
    };

    // .................On Form Finish........................................................


    const handleVerification = async () => {
        if (code.some((char) => char === "")) {
            message.error("Please enter the complete OTP code.");
            return;
        }

        const otpCode = code.join("");
        try {
            const response = await axios.patch(
                `https://stonecore-2024.uc.r.appspot.com/v1/auth/otp/verify/${userId}`,
                { otp: otpCode }
            );

            message.success("Email verified successfully.");
            if (response.data.success === true) {
                navigate("/");
            }

        } catch (error) {
            message.error("invalid OTP");
            console.error("Error:", error);
        }
    };


    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingTop: "5%" }}>
            <h1>Verify Email</h1>
            <div className="verification-name">An Email with Verification Code has been sent to your email</div>
            <div style={{ marginTop: "2%" }}>
                <img alt="email_img" src={email4} width={200} />
            </div>
            <Form

            >
                <Row gutter={8} justify="center" style={{ marginTop: "20px" }}>
                    {code.map((char, index) => (
                        <Col key={index}>
                            <Form.Item>
                                <Input
                                    id={`code-input-${index}`}
                                    type="text"
                                    maxLength="1"
                                    value={char}
                                    onChange={(e) => handleChange(e, index)}
                                    onPaste={handlePaste}
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        textAlign: "center",
                                        fontSize: "20px",
                                        borderRadius: "4px"
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    ))}
                </Row>
            </Form>




            <div >
                <p>
                    Did not receive a code?
                    <Button type="link" onClick={handleResend} disabled={resendDisabled}>
                        Request Again {resendDisabled && `(${timer}s)`}
                    </Button>
                </p>
            </div>


            <Button
                type="primary"
                htmlType="submit"
                className="ant-btn-custom"
                onClick={handleVerification}

            >
                Verify Email
            </Button>

        </div>
    )
};


export default EmailVerification;